export const Home = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0003 15C13.7903 16.333 10.2083 16.333 8.00027 15M19.0003 8.71001L13.6673 4.56201C13.1993 4.19792 12.6232 4.00024 12.0303 4.00024C11.4373 4.00024 10.8613 4.19792 10.3933 4.56201L5.05927 8.71001C4.73872 8.9593 4.47937 9.27854 4.30103 9.64336C4.12269 10.0082 4.03008 10.4089 4.03027 10.815V18.015C4.03027 18.5454 4.24099 19.0542 4.61606 19.4292C4.99113 19.8043 5.49984 20.015 6.03027 20.015H18.0303C18.5607 20.015 19.0694 19.8043 19.4445 19.4292C19.8196 19.0542 20.0303 18.5454 20.0303 18.015V10.815C20.0303 9.99201 19.6503 9.21501 19.0003 8.71001Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
